export default {
  path: '/',
  params: {},
  query: {},
  type: 'transfer',
  unSavedForm: false,
  nextRoute: null,
  isPanelOpen: false,
};
